import { AiIncidentsTable } from '../../entities/ai-incidents';

const AiIncidents = () => <AiIncidentsTable />;

export default AiIncidents;
